<div
    class="modal-backdrop"
    aria-describedby="modal-description"
    aria-modal="true"
    role="dialog"
    [attr.aria-labelledby]="isDisabled ? 'modal-title-disabled' : 'modal-title'"
    (click)="onBackdropClick($event)"
>
    @if (displayData) {
        <div class="modal-content" [class.disabled-state]="isDisabled" #modalContent role="document" tabindex="-1">
            <button
                class="close-button"
                #closeButton
                type="button"
                [attr.aria-label]="'Close ' + displayData.deviceName + ' engraving modal'"
                (click)="onClose()"
            >
                <svg
                    aria-hidden="true"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M18 6L6 18M6 6L18 18"
                        stroke="currentColor"
                    />
                </svg>
            </button>

            @if (!isDisabled) {
                <div class="modal-title-container">
                    <h1 id="modal-title" class="section-heading">Personalize your {{ displayData.deviceName }}</h1>
                    <div id="modal-description" class="sr-only">
                        Add custom engraving to your {{ displayData.deviceName }}. Use Tab to navigate and Enter to
                        interact with elements.
                    </div>
                </div>
            }

            <div class="product-preview" [class.disabled-layout]="isDisabled">
                @if (isDisabled) {
                    <!-- Disabled modal: side-by-side layout -->
                    <h1 id="modal-title-disabled" class="sr-only">
                        {{ displayData.deviceName }} Configuration Summary
                    </h1>

                    <div class="disabled-content">
                        <div class="device-image-container">
                            <img
                                class="device-img"
                                [alt]="
                                    'Image of ' +
                                    displayData.image.alt +
                                    (hasEngraving() ? ' with engraving preview' : '')
                                "
                                [src]="displayData.image.src"
                            />
                        </div>
                        <div class="product-info">
                            <div class="product-info-title">{{ getDisabledTitle() }}</div>
                            @if (engravingText.firstLine || engravingText.secondLine) {
                                <div class="engraving-status-container">
                                    <div class="engraving-status">
                                        <span class="engraved-icon" aria-hidden="true">
                                            <svg
                                                fill="none"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                width="20"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.95573 1.76251C5.2474 1.76251 1.41406 5.59168 1.41406 10.3042C1.41406 15.0167 5.2474 18.8458 9.95573 18.8458C14.6641 18.8458 18.4974 15.0125 18.4974 10.3042C18.4974 5.59585 14.6682 1.76251 9.95573 1.76251ZM9.95573 17.5958C5.9349 17.5958 2.66406 14.325 2.66406 10.3042C2.66406 6.28335 5.9349 3.01251 9.95573 3.01251C13.9766 3.01251 17.2474 6.28335 17.2474 10.3042C17.2474 14.325 13.9766 17.5958 9.95573 17.5958Z"
                                                    fill="#2E2E2E"
                                                />
                                                <path
                                                    d="M14.0193 7.99585H5.89844C5.5526 7.99585 5.27344 8.27502 5.27344 8.62085C5.27344 8.96668 5.5526 9.24585 5.89844 9.24585H14.0193C14.3651 9.24585 14.6443 8.96668 14.6443 8.62085C14.6443 8.27502 14.3651 7.99585 14.0193 7.99585Z"
                                                    fill="#2E2E2E"
                                                />
                                                <path
                                                    d="M13.1969 11.3625H6.73438C6.38854 11.3625 6.10938 11.6417 6.10938 11.9875C6.10938 12.3333 6.38854 12.6125 6.73438 12.6125H13.1969C13.5427 12.6125 13.8219 12.3333 13.8219 11.9875C13.8219 11.6417 13.5427 11.3625 13.1969 11.3625Z"
                                                    fill="#2E2E2E"
                                                />
                                            </svg>
                                        </span>
                                        <span class="engraved-text">Engraved</span>
                                    </div>
                                    <div
                                        class="engraving-text-display"
                                        aria-label="Current engraving text"
                                        role="region"
                                    >
                                        @if (engravingText.firstLine) {
                                            <div class="engraving-line" aria-label="First line of engraving">
                                                {{ engravingText.firstLine }}
                                            </div>
                                        }
                                        @if (engravingText.secondLine) {
                                            <div class="engraving-line" aria-label="Second line of engraving">
                                                {{ engravingText.secondLine }}
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                } @else {
                    <!-- Editable modal: original layout with overlay -->
                    <div class="device-container">
                        <img
                            class="device-img"
                            [alt]="
                                'Preview of ' +
                                displayData.image.alt +
                                (hasEngraving()
                                    ? ' showing engraving: ' +
                                      engravingText.firstLine +
                                      (engravingText.secondLine ? ' ' + engravingText.secondLine : '')
                                    : '')
                            "
                            [src]="displayData.image.src"
                        />

                        @if (engravingText.firstLine || engravingText.secondLine) {
                            <div
                                class="engraving-preview"
                                role="img"
                                [attr.aria-label]="
                                    'Engraving preview: ' +
                                    engravingText.firstLine +
                                    (engravingText.secondLine ? ', ' + engravingText.secondLine : '')
                                "
                            >
                                <div class="engraving-text">
                                    @if (engravingText.firstLine) {
                                        <div class="engraving-line">{{ engravingText.firstLine }}</div>
                                    }
                                    @if (engravingText.secondLine) {
                                        <div class="engraving-line">{{ engravingText.secondLine }}</div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>

            @if (!isDisabled) {
                <form class="engraving-form" aria-labelledby="modal-title" role="form">
                    <div class="form-group">
                        <input
                            id="firstLine"
                            class="engraving-input"
                            [class.error]="!isFirstLineValid() && engravingText.firstLine.length > 0"
                            #firstLineInput
                            aria-label="First line of engraving (required)"
                            autocomplete="off"
                            matInput
                            name="firstLine"
                            placeholder=" "
                            type="text"
                            [attr.aria-describedby]="
                                !isFirstLineValid() && engravingText.firstLine.length > 0 ? 'firstLine-error' : null
                            "
                            [attr.aria-invalid]="!isFirstLineValid() && engravingText.firstLine.length > 0"
                            [maxlength]="displayData.maxCharactersPerLine"
                            [(ngModel)]="engravingText.firstLine"
                        />

                        <label aria-hidden="true" for="firstLine">First line</label>
                        @if (!isFirstLineValid() && engravingText.firstLine.length > 0) {
                            <div id="firstLine-error" class="error-message" role="alert">
                                First line must be between 1 and {{ displayData.maxCharactersPerLine }} characters
                            </div>
                        }
                    </div>

                    <div class="form-group">
                        <input
                            id="secondLine"
                            class="engraving-input"
                            [class.error]="!isSecondLineValid() && engravingText.secondLine.length > 0"
                            aria-label="Second line"
                            autocomplete="off"
                            name="secondLine"
                            placeholder=" "
                            type="text"
                            [attr.aria-describedby]="
                                !isSecondLineValid() && engravingText.secondLine.length > 0 ? 'secondLine-error' : null
                            "
                            [attr.aria-invalid]="!isSecondLineValid() && engravingText.secondLine.length > 0"
                            [maxlength]="displayData.maxCharactersPerLine"
                            [(ngModel)]="engravingText.secondLine"
                        />
                        <label aira-hidden="true" for="secondLine">Second line</label>
                        @if (!isSecondLineValid() && engravingText.secondLine.length > 0) {
                            <div id="secondLine-error" class="error-message" role="alert">
                                Second line must be {{ displayData.maxCharactersPerLine }} characters or fewer
                            </div>
                        }
                    </div>
                </form>

                <div class="engraving-info" aria-label="Important engraving information" role="region">
                    <p class="body-1">
                        Laser engraving is permanent. Emoji can't be engraved. Please check to make sure everything is
                        spelled correctly.
                    </p>
                    <p class="body-1">
                        Engraved products may have extended delivery dates and can't be returned unless damaged or
                        defective.
                    </p>
                </div>

                <div class="modal-actions" aria-label="Engraving options" role="group">
                    <button
                        mat-raised-button
                        type="button"
                        [attr.aria-describedby]="!canSave() ? 'save-disabled-help' : null"
                        [disabled]="!canSave()"
                        (click)="onSave()"
                    >
                        Save engraving
                    </button>
                    @if (!canSave()) {
                        <div id="save-disabled-help" class="sr-only">
                            Save button is disabled. Please enter valid text in the first line to enable saving.
                        </div>
                    }
                    <button mat-stroked-button type="button" (click)="onSkip()">Skip engraving</button>
                </div>
            }
        </div>
    }
</div>
